
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/artist/[pid]",
      function () {
        return require("private-next-pages/artist/[pid]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/artist/[pid]"])
      });
    }
  